/** The generated front is separate from the transcript/exercise that supplied it. */
export function isGenericFlashcardHeading(text: string): boolean {
  return /^(?:verb conjugation|language practice|sorting drill|grammar exercise)$/iu.test(
    text.trim()
  );
}

export function getGeneratedFlashcardText(data: { targetText?: unknown }): string {
  const text =
    typeof data.targetText === "string" ? data.targetText.trim().replace(/\s+/g, " ") : "";
  if (
    !text ||
    text.length > 500 ||
    !/\p{L}/u.test(text) ||
    /_{2,}/u.test(text) ||
    isGenericFlashcardHeading(text) ||
    /^(?:here (?:is|are) your|your (?:first|next) sentence\s*:|translate (?:this|the following)\b)/iu.test(
      text
    )
  ) {
    throw new Error("Choose a target-language word or phrase to save.");
  }
  return text;
}
